import { useLayoutEffect, useState } from "react";

//"Custom Hook" die die Anwendung neu rendert, wenn sich die Fenstergröße ändert
export const useWindowWidth= () => {
  const [width, setWidth] = useState(window.innerWidth)

  useLayoutEffect(() => {
    function updateWidth() {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', updateWidth);
    updateWidth();

  // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => window.removeEventListener('resize', updateWidth);
  }, [])

  return width;
}
